<template>
  <span>
    <span :title="getFileCount()" @click="openFileVersionAdmin" :class="fileCountButtonStyle()" v-if="hasFileCount()"><Icon icon="grommet-icons:multiple" width="15" /></span>
    <span :title="getDocumentName()">{{ getDocumentName() }}</span>
  </span>
</template>

<script >
import { Icon } from '@iconify/vue';

export default {
  name: "DocumentNameColumn",
  methods: {
    getDocumentName() {
      return this.params.value[1];
    },

    hasFileCount() {
      return this.params.value[2] > 1;
    },

    getFileCount() {
      return this.params.value[2];
    },

    openFileVersionAdmin() {
      if (this.params.userEditAccessLevel) {
        this.params.openFileVersionAdmin(this.params.value[0], this.params.value[1]);
      }
    },

    fileCountButtonStyle() {
      return this.params.userEditAccessLevel ? "fileCountButtonPoint" : "fileCountButton";
    }
  },
  components: {
    Icon,
  }
}
</script>

<style>
.fileCountButton {
  margin-right: 10px;
}

.fileCountButtonPoint {
  margin-right: 10px;
  cursor: pointer;
}
</style>